// pt-BR strings (react-i18next). Every user-facing string lives here; English comes later (A11).
import { atividadesPt } from './pt-BR/atividades.ts';
import { processoTabsPt } from './pt-BR/processoTabs.ts';
import { processosPt } from './pt-BR/processos.ts';
import { shellPt } from './pt-BR/shell.ts';
import { territorioPt } from './pt-BR/territorio.ts';

export const ptBR = {
  brand: { name: 'Requerimento' },
  filter: { label: 'Filtrar por titular', all: 'Todos os titulares', summary: '{{entities}} titulares · {{processes}} proc.' },
  nav: {
    hoje: 'Hoje',
    prazos: 'Prazos',
    sei: 'SEI',
    carteira: 'Carteira',
    consulta: 'Consulta',
    sobreposicao: 'Sobreposição',
    oportunidades: 'Oportunidades',
    superficiarios: 'Superficiários',
    alertas: 'Alertas',
    cobranca: 'Cobrança',
    onboarding: 'Começar',
    consultor: 'Consultor',
    equipe: 'Equipe',
    status: 'Status',
    statusDot: 'Fontes: {{state}}',
  },
  sync: {
    never: 'nunca',
  },
  status: {
    title: 'Status das fontes',
    checkedAt: 'Conferido em {{date}} às {{time}} (horário de Brasília). Atualiza a cada minuto.',
    filters: 'Filtrar por status',
    all: 'Todos',
    withWarnings: 'Com avisos',
    columns: {
      source: 'Fonte / conjunto',
      state: 'Status',
      frequency: 'Frequência',
      lastCheck: 'Última verificação',
      nextRun: 'Próxima extração',
      dataThrough: 'Dados até',
      warnings: 'Avisos',
    },
    states: { ok: 'OK', waiting: 'Aguardando publicação', stale: 'Atrasado', degraded: 'Degradado', never: 'Nunca executado', failed: 'Falhou' },
    frequency: { daily: 'Diária', monthly: 'Mensal', yearly: 'Anual', frozen: 'Sem atualização desde {{year}}' },
    unchanged: 'sem mudança',
    lag: 'T−{{days}}',
    groups: {
      dou: 'Diário Oficial da União',
      scm: 'ANM · Cadastro Mineiro (SCM)',
      sigmine: 'ANM · SIGMINE',
      pd: 'ANM · Protocolo Digital',
      finance: 'ANM · Dados abertos (financeiro)',
      ibama: 'IBAMA',
      estaduais: 'Órgãos ambientais estaduais',
      // the groups before the state agencies were one (an API not yet redeployed still sends them)
      imaSc: 'IMA-SC',
      iatPr: 'IAT-PR',
      incra: 'INCRA',
      funai: 'FUNAI',
      anbima: 'ANBIMA',
      internal: 'Processamento interno',
    },
    datasets: {
      douDaily: 'Edição diária (INLABS)',
      scmEvents: 'Processos/Eventos',
      scmHolders: 'Titulares',
      sigmineEvents: 'Últimos eventos',
      sigminePolygons: 'Polígonos',
      sigmineBloqueios: 'Áreas de bloqueio',
      sigmineReservas: 'Reservas garimpeiras',
      pdFilings: 'Protocolos',
      pdOutages: 'Indisponibilidades',
      tah: 'TAH (pagamentos)',
      sda: 'Dívida ativa',
      cfem: 'CFEM',
      cfemPayments: 'Arrecadação',
      cfemFines: 'Autuações',
      ibamaAutos: 'Autos de infração',
      ibamaEmbargos: 'Termos de embargo',
      ibamaNotificacoes: 'Notificações',
      imaSc: 'IMA-SC (Santa Catarina)',
      imaScLicencas: 'Licenças ambientais (mineração)',
      iatPr: 'IAT-PR (Paraná)',
      iatPrLicencas: 'Licenças ambientais dos titulares',
      iatPrProtocolos: 'Protocolos acompanhados (e-Protocolo)',
      terrasIndigenas: 'Terras indígenas',
      unidadesConservacao: 'Unidades de conservação',
      assentamentos: 'Assentamentos',
      quilombolas: 'Territórios quilombolas',
      sigef: 'Imóveis certificados (SIGEF)',
      holidays: 'Feriados nacionais',
      match: 'Vinculação provisória',
      ibamaPlacement: 'Vinculação IBAMA aos processos',
      imaScPlacement: 'Vinculação IMA-SC aos processos',
      iatPrPareceres: 'Pareceres técnicos do IAT',
      iatPrPlacement: 'Vinculação IAT-PR aos processos',
      obligations: 'Prazos (recálculo noturno)',
    },
    warnings: {
      never: 'Nenhuma coleta registrada.',
      failed: 'A última coleta falhou. Tentamos de novo no próximo horário.',
      degraded: 'A última coleta terminou com problemas.',
      stale: 'Nenhuma coleta bem-sucedida dentro do prazo esperado.',
      frozen: 'A fonte não publica dados novos desde {{date}}.',
    },
    notes: { tahFromScm: 'A situação atual da TAH vem dos eventos do SCM.' },
    moduleOnly: { ambiental: 'Somente módulo Ambiental', territorio: 'Somente módulo Território' },
    outage: {
      title: 'Protocolo Digital fora do ar desde {{date}} às {{time}}',
      body: 'Indisponibilidade publicada pela ANM. Os prazos já consideram a indisponibilidade (Res. ANM 16/2019, arts. 81–82).',
      until: 'Previsão de retorno: {{date}} às {{time}}.',
    },
    problems: {
      title_one: 'Um conjunto com problema na coleta',
      title_other: '{{count}} conjuntos com problema na coleta',
    },
    legend: {
      lastCheck: 'quando baixamos ou conferimos a fonte pela última vez, com qualquer resultado.',
      dataThrough: 'a data mais recente nos dados que a fonte publicou.',
    },
  },
  rest: {
    title: 'Nada exige ação hoje',
    checkedAt: 'Fontes conferidas às {{time}}',
    checkedOn: 'Fontes conferidas até {{date}}',
    checked: 'O que foi verificado',
    note: 'Dias sem pendências são a maioria — o silêncio aqui é informação, não falta de dados.',
  },
  degraded: {
    title: 'Dados possivelmente desatualizados',
    body: 'Não conseguimos confirmar {{sources}} desde {{since}}. Até lá, não afirmamos que nada exige ação.',
  },
  loading: 'Carregando…',
  hoje: {
    title_one: 'Uma coisa exige ação hoje',
    title_other: '{{count}} coisas exigem ação hoje',
    titleNone: 'Nada exige ação hoje — só movimentos para conferir',
    actNow: 'Ação necessária',
    movements: 'Movimentos para conferir',
    ignored_one: 'Um movimento sem ação',
    ignored_other: '{{count}} movimentos sem ação',
    open: 'Abrir →',
    checks: { fresh: 'em dia' },
  },
  countdown: {
    left_one: 'dia restante',
    left_other: 'dias restantes',
    today: 'vence hoje',
    overdue_one: 'dia de atraso',
    overdue_other: 'dias de atraso',
    due: 'vence {{date}}',
    published: 'publicado {{date}}',
    recorded: 'ato de {{date}}',
    undated: 'sem data',
  },
  provenance: {
    stated: 'Prazo lido no ato',
    derived: 'Prazo derivado',
    manual: 'Prazo registrado por você',
    tiers: {
      PARSED_FROM_PUBLICATION: 'lidos no DOU',
      EVENT_TYPE_RULE: 'no nome do evento',
      TITLE_EXPIRY: 'vencimento de título',
      STATUTORY_DERIVATION: 'derivados de regra legal',
      RECURRING_CALENDAR: 'obrigações recorrentes',
      DEFENSIVE: 'cautelares',
      MANUAL: 'registrados por você',
      OUTSIDE_LICENCE: 'licença sem processo minerário',
    },
    confidence: { high: 'confiança alta', medium: 'confiança média', low: 'confiança baixa' },
  },
  obligation: {
    manualTitle: 'Prazo registrado',
    manualLicenceTitle: 'Licença cadastrada por você',
    outsideLicenceRenew: 'Pedir a renovação da licença',
    outsideLicenceExpiry: 'Vencimento da licença',
    outsideLicenceOrigin: 'Licença do titular que o {{agency}} não vincula a nenhum processo minerário — {{activity}}. O prazo termina quando o órgão registrar a renovação.',
    noActivity: 'atividade não informada',
    noMiningProcess: 'Sem processo minerário',
    confirmedLicenceTitle: 'Licença confirmada por você',
    landAgreementTitle: 'Fim do acordo com o superficiário',
    landAgreementOrigin: 'Acordo cadastrado por você em Território → Superficiários — para encerrar este prazo, edite ou remova o acordo.',
    confirmedLicenceOrigin: 'Licença do órgão que você confirmou como do titular — para encerrar este prazo, desfaça a confirmação no processo.',
    manualLicenceOrigin: 'Licença cadastrada por você no processo — para encerrar este prazo, remova a licença ou cadastre a renovada.',
    manualFrom: 'Origem: {{document}} · SEI {{nup}}',
    seiDocument: 'documento do SEI',
    seiProcess: 'SEI {{nup}}',
    kinds: {
      RESPOND_TO_CONDITION: 'Responder exigência',
      SUBMIT_REPORT: 'Entregar relatório',
      PAY_FEE: 'Pagar taxa',
      RENEW_TITLE: 'Renovar título',
      START_ACTIVITY: 'Iniciar atividade',
      PERIODIC_REPORT: 'Relatório periódico',
      FILE_EXTENSION: 'Pedir prorrogação',
      FILE_DEFENSE: 'Apresentar defesa',
      FILE_APPEAL: 'Apresentar recurso',
      FILE_APPLICATION: 'Protocolar requerimento',
      PAY_PENALTY: 'Pagar multa',
    },
    acknowledge: 'Ciente',
    acknowledged: 'ciente — {{who}} · {{when}}',
    resolve: 'Resolver',
    resolved: 'resolvido — {{who}} · {{reason}}',
    reason: 'Como foi resolvido?',
    reasonHint: 'Ao menos 3 caracteres.',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    failed: 'Não foi possível salvar. Tente de novo.',
    flags: {
      filing_unconfirmed: 'O protocolo deste cumprimento não apareceu no Cadastro Mineiro em 10 dias — o prazo voltou a contar. Confira o protocolo.',
      filing_provisional: 'Cumprimento protocolado (Protocolo Digital) — registro da ANM pendente.',
      prorrogacao_solicitada: 'Prorrogação solicitada — aguardando a decisão da ANM.',
      possibly_withdrawn: 'Possivelmente tornado sem efeito — confira.',
    },
    filedPending: 'Protocolados, aguardando registro da ANM',
    source: {
      label: 'Origem',
      dou: 'Publicado no DOU de {{date}}',
      section: 'Seção {{n}}',
      sectionExtra: 'Seção {{n}} – Extra',
      edition: 'edição {{n}}',
      event: 'Ato de {{date}}',
      openDou: 'Abrir a página do DOU',
      excerpt: 'Trecho do ato',
      fullText: 'Ler o trecho completo',
    },
  },
  sources: {
    label: 'Fontes',
    scm: 'Cadastro Mineiro',
    dou: 'Diário Oficial',
    sigmine: 'SIGMINE',
    pd: 'Protocolo Digital',
    sei: 'SEI',
    ibama: 'IBAMA',
    imaSc: 'IMA-SC',
    iatPr: 'IAT-PR',
  },
  prazos: {
    title: 'Prazos',
    subtitle_one: 'Uma obrigação no período.',
    subtitle_other: '{{count}} obrigações no período.',
    subtitleSource: 'Cada prazo mostra de onde veio — lido no Diário Oficial, derivado de regra legal, ou vencimento de título.',
    radar: 'Distribuição no tempo',
    bands: { crit: 'crítico · ≤ 15 d', warn: 'atenção · 16–45 d', plan: 'planejado · 46–90 d' },
    today: 'hoje · {{date}}',
    undated: 'Sem data definida',
    overdue: 'Vencidos',
    none: 'Nenhuma obrigação no período.',
    filter: 'Filtrar por categoria',
    allCategories: 'Todos',
    list: 'Prazos por data',
    category: {
      PARSED_FROM_PUBLICATION: 'Lido no DOU',
      EVENT_TYPE_RULE: 'Pelo nome do evento',
      TITLE_EXPIRY: 'Vencimento de título',
      STATUTORY_DERIVATION: 'Regra legal',
      RECURRING_CALENDAR: 'Recorrente',
      DEFENSIVE: 'Cautelar',
      MANUAL: 'Registrado por você',
      env_outside: 'Ambiental (sem processo minerário)',
      sei_outside: 'SEI (sem processo minerário)',
    },
    how: 'Como estes prazos são calculados',
    howBody:
      'Prazos lidos no DOU vêm do texto publicado do próprio ato. Prazos derivados aplicam uma regra legal a um evento, e prazos de vencimento de título vêm do campo oficial do Cadastro Mineiro. Nenhum cálculo substitui a conferência do processo.',
  },
  processo: {
    title: 'Processo {{ref}}',
    titular: 'Titular',
    area: 'Área',
    links: 'Links',
    nup: 'NUP {{nup}}',
    dou: 'DOU · {{date}}',
    timeline: 'Linha do tempo',
    events_one: 'um evento',
    events_other: '{{count}} eventos',
    obligations: 'Obrigações',
    titles: 'Títulos',
    parties: 'Partes',
    noObligations: 'Nenhuma obrigação aberta neste processo.',
    upsellTitle: 'A partir daqui é assinatura',
    upsellBody: 'Assine para ver prazos, a tradução de cada movimento e ser avisado quando algo mudar.',
    upsellCta: 'Ver planos',
    notFound: 'Processo não encontrado.',
  },
  consulta: {
    process: 'Processo na ANM',
    tabs: 'Seções do processo',
    badge: 'Consulta grátis',
    title: 'Consulte qualquer processo da ANM',
    subtitle: 'Busca sobre o dado público do Cadastro Mineiro. Para ser avisado quando algo mudar e ver os movimentos recentes, é preciso assinar.',
    label: 'Número do processo, CPF, CNPJ ou nome do titular',
    placeholder: 'ex.: 868.092/2015 · 12.345.678/0001-90 · Mineração Sabatel',
    search: 'Buscar',
    tooShort: 'Digite ao menos 2 caracteres.',
    none: 'Nada encontrado para “{{q}}”.',
    people: 'Titulares encontrados',
    processes: 'Processos',
    processCount_one: 'um processo',
    processCount_other: '{{count}} processos',
    rawEvents: 'Eventos — dado bruto do SCM',
    ghost: 'Movimentos recentes — assine para ver',
    ghostRange: 'últimos {{days}} d · {{from}} a {{to}}',
    ghostNote: 'A janela recente fica oculta na consulta grátis — mesmo quando nada ocorreu, para não revelar atividade.',
    paywallTitle: 'Assine para ser avisado, não só consultar',
    paywallCta: 'Ver planos',
    limitTitle: 'Você chegou ao limite de consultas grátis de hoje',
    limitBody: 'Crie uma conta grátis para continuar consultando — leva um minuto.',
    limitCta: 'Criar conta grátis',
    slowDown: 'Muitas consultas seguidas. Aguarde um minuto e tente de novo.',
    back: '← Voltar à busca',
  },
  auth: {
    title: 'Entrar',
    subtitle: 'Acompanhe prazos e movimentações dos seus processos na ANM.',
    email: 'E-mail',
    password: 'Senha',
    showPassword: 'Mostrar senha',
    hidePassword: 'Ocultar senha',
    submit: 'Entrar',
    submitting: 'Entrando…',
    forgot: 'Esqueci minha senha',
    noAccount: 'Ainda não tem conta?',
    toSignUp: 'Criar conta',
    consultaFree: 'A Consulta grátis funciona sem conta.',
    toConsulta: 'Ir para a Consulta',
    noCustomerTitle: 'Comece pela sua carteira',
    noCustomerBody: 'Sua conta ainda não monitora nenhum titular. Cadastre a conta (CPF ou CNPJ) e escolha os processos.',
    noCustomerCta: 'Começar →',
    twoFactor: {
      title: 'Verificação em duas etapas',
      body: 'Sua conta pede um segundo passo para entrar.',
      totp: 'App autenticador',
      otp: 'Código por e-mail',
      backup: 'Código de recuperação',
      totpHint: 'Digite o código de 6 dígitos que o app mostra agora.',
      otpHint: 'Enviamos um código de 6 dígitos para o seu e-mail. Ele vale por 10 minutos.',
      otpSend: 'Enviar código por e-mail',
      otpResend: 'Enviar outro código',
      otpSent: 'Código enviado. Confira sua caixa de entrada.',
      backupHint: 'Use um dos códigos de recuperação que você guardou ao ativar o app.',
      code: 'Código',
      trust: 'Não pedir de novo neste navegador por 30 dias',
      verify: 'Confirmar',
      back: 'Voltar',
    },
    errors: {
      credentials: 'E-mail ou senha incorretos.',
      notVerified: 'Seu e-mail ainda não foi confirmado. Enviamos um novo código.',
      exists: 'Já existe uma conta com este e-mail. Entre com sua senha ou use “Esqueci minha senha”.',
      passwordShort: 'A senha precisa ter pelo menos {{min}} caracteres.',
      codeInvalid: 'Código incorreto. Confira e tente de novo.',
      codeExpired: 'Este código expirou. Peça um novo.',
      tooManyAttempts: 'Muitas tentativas com este código. Peça um novo.',
      locked: 'Muitas tentativas sem sucesso. Por segurança, aguarde alguns minutos e tente de novo.',
      rateLimited: 'Muitas tentativas em pouco tempo. Aguarde um minuto e tente de novo.',
      network: 'Não conseguimos falar com o Requerimento. Verifique sua conexão e tente de novo.',
      generic: 'Não foi possível concluir agora. Tente de novo; se continuar, fale com o suporte.',
    },
  },
  cadastro: {
    title: 'Criar conta',
    subtitle: 'Leva um minuto. Você confirma o e-mail com um código e já pode encontrar seus processos.',
    name: 'Seu nome',
    passwordHint: 'Pelo menos {{min}} caracteres. Uma frase longa é mais segura que símbolos.',
    submit: 'Criar conta',
    submitting: 'Criando…',
    haveAccount: 'Já tem conta?',
    toSignIn: 'Entrar',
    nothingCharged: 'Criar a conta não cobra nada. O cartão ou o Pix só aparecem quando você escolher um plano.',
  },
  verificar: {
    title: 'Confirme seu e-mail',
    body: 'Enviamos um código de 6 dígitos para {{email}}. Ele vale por 10 minutos.',
    bodyNoEmail: 'Digite o e-mail da conta e o código de 6 dígitos que enviamos.',
    code: 'Código',
    submit: 'Confirmar e-mail',
    resend: 'Enviar outro código',
    resendIn: 'Enviar outro código em {{seconds}} s',
    resent: 'Enviamos um novo código.',
    wrongEmail: 'Não é este e-mail? Criar a conta de novo',
  },
  esqueci: {
    title: 'Esqueci minha senha',
    body: 'Digite o e-mail da conta. Enviaremos um código para você criar uma senha nova.',
    send: 'Enviar código',
    codeBody: 'Se houver uma conta com {{email}}, enviamos um código de 6 dígitos. Ele vale por 10 minutos.',
    newPassword: 'Nova senha',
    submit: 'Salvar nova senha',
    done: 'Senha alterada. Entre com a nova senha.',
    toSignIn: 'Entrar',
  },
  conta: {
    signedInAs: 'Conectado como',
    customer: 'Conta',
    switchCustomer: 'Trocar de conta',
    roleOwner: 'administrador',
    roleMember: 'membro',
    security: 'Segurança',
    signOut: 'Sair',
    signIn: 'Entrar',
    signUp: 'Criar conta',
  },
  mfaBanner: {
    title: 'Proteja sua conta',
    body: 'Ative a verificação em duas etapas: além da senha, um código do seu e-mail ou de um app autenticador.',
    cta: 'Ativar agora',
    dismiss: 'Agora não',
  },
  seguranca: {
    title: 'Segurança',
    subtitle: 'Senha e verificação em duas etapas da sua conta.',
    twoFactor: 'Verificação em duas etapas',
    on: 'Ativada. Pedimos um código a cada novo acesso.',
    off: 'Desativada. Hoje basta a senha para entrar na sua conta.',
    chooseTitle: 'Escolha como receber o segundo código',
    otpTitle: 'Código por e-mail',
    otpBody: 'A cada acesso, enviamos um código para {{email}}. Simples, sem instalar nada.',
    totpTitle: 'App autenticador',
    totpBody: 'Google Authenticator, Microsoft Authenticator, 1Password e similares. Funciona sem internet no celular.',
    choose: 'Usar este',
    confirmPassword: 'Confirme sua senha para continuar',
    continue: 'Continuar',
    cancel: 'Cancelar',
    otpEnabled: 'Pronto: a verificação em duas etapas por e-mail está ativada.',
    totpStep1: '1. No app autenticador, adicione uma conta com esta chave:',
    totpOpen: 'Abrir no app autenticador (neste aparelho)',
    totpStep2: '2. Guarde estes códigos de recuperação num lugar seguro. Cada um entra uma única vez, se você perder o celular:',
    totpStep3: '3. Digite o código que o app mostra para confirmar:',
    totpConfirm: 'Confirmar e ativar',
    totpEnabled: 'Pronto: o app autenticador está ativado.',
    copy: 'Copiar',
    copied: 'Copiado',
    disable: 'Desativar verificação em duas etapas',
    disableConfirm: 'Desativar',
    disabled: 'A verificação em duas etapas foi desativada.',
  },
  restrictions: {
    since: 'desde {{date}}',
    inArea_one: 'Restrição na área: 1',
    inArea_other: 'Restrições na área: {{count}}',
    onProcess_one: 'Restrição sobre a área do processo: 1',
    onProcess_other: 'Restrições sobre a área do processo: {{count}}',
  },
  parcels: {
    inArea_one: 'Imóvel certificado (SIGEF) na área: 1',
    inArea_other: 'Imóveis certificados (SIGEF) na área: {{count}}',
    onProcess_one: 'Imóvel certificado (SIGEF) sob o processo: 1',
    onProcess_other: 'Imóveis certificados (SIGEF) sob o processo: {{count}}',
    unnamed: 'Imóvel sem denominação',
    matricula: 'matrícula {{matricula}}',
    cns: 'cartório CNS {{cns}}',
    registeredOn: 'registrado em {{date}}',
    sncr: 'SNCR {{code}}',
    howToOwner: 'O proprietário consta da certidão de matrícula, que qualquer pessoa pode pedir ao cartório indicado.',
  },
  car: {
    inArea_one: 'Imóvel rural declarado no CAR na área: 1',
    inArea_other: 'Imóveis rurais declarados no CAR na área: {{count}}',
    onProcess_one: 'Imóvel rural declarado no CAR sob o processo: 1',
    onProcess_other: 'Imóveis rurais declarados no CAR sob o processo: {{count}}',
    type: { IRU: 'Imóvel rural', AST: 'Assentamento', PCT: 'Povos e comunidades tradicionais' },
    status: { AT: 'Ativo', PE: 'Pendente', SU: 'Suspenso' },
    declared: '{{area}} declarados',
    note: 'Dados declarados pelo próprio interessado no CAR (Serviço Florestal Brasileiro). Não comprovam propriedade.',
    truncated: 'Área grande: o CAR devolveu o limite de 10.000 imóveis; a lista pode estar incompleta.',
    unavailable: 'CAR indisponível agora: o servidor do Serviço Florestal Brasileiro não respondeu. Tente de novo mais tarde.',
  },
  ambiental: {
    title: 'Licenciamento ambiental',
    locked: 'Licenças e pedidos no {{agencies}}: disponível com o módulo Ambiental.',
    licence: 'Licença',
    licences_one: 'Licenças ({{count}})',
    licences_other: 'Licenças ({{count}})',
    requests_one: 'Pedidos acompanhados ({{count}})',
    requests_other: 'Pedidos acompanhados ({{count}})',
    noLicences: 'Nenhuma licença do órgão ambiental vinculada a este processo.',
    noRequests: 'Nenhum pedido acompanhado.',
    manual: 'cadastrada por você',
    issuedOn: 'emitida em {{date}}',
    validUntil: 'válida até {{date}}',
    expiredOn: 'vencida em {{date}}',
    delisted: 'Deixou de constar na consulta do órgão em {{date}} (suspensa, cancelada ou substituída?)',
    remove: 'Remover',
    followedByYou: 'acompanhado por você',
    verified: 'confirmado pelo órgão (CNPJ do titular)',
    missing: 'O órgão não encontrou este número — confira se foi digitado certo.',
    notCheckedYet: 'Ainda não consultado — a primeira consulta sai na próxima rodada diária.',
    filedOn: 'protocolado em {{date}}',
    location: 'em {{unit}}',
    lastStep: 'último andamento em {{date}}',
    steps_one: 'Ver {{count}} andamento',
    steps_other: 'Ver {{count}} andamentos',
    stopFollowing: 'Deixar de acompanhar',
    status: {
      filed: 'protocolado',
      in_analysis: 'em análise',
      documents_requested: 'documentação solicitada',
      granted: 'concedido',
      refused: 'indeferido',
      archived: 'arquivado',
      suspended: 'suspenso',
    },
    addRequest: 'Acompanhar um pedido',
    addLicence: 'Cadastrar uma licença',
    trackTitle: 'Acompanhar um pedido pelo número',
    agency: 'Órgão',
    number: 'Número do protocolo',
    trackNote: 'Consultamos a tramitação pública todos os dias. O pedido fica visível só para a sua conta, até o órgão confirmar que é do titular.',
    trackError: 'Não foi possível acompanhar este número. Confira o formato.',
    follow: 'Acompanhar',
    cancel: 'Cancelar',
    licenceTitle: 'Cadastrar uma licença',
    type: 'Tipo',
    licenceNumber: 'Número (opcional)',
    issued: 'Emitida em (opcional)',
    valid: 'Válida até',
    notes: 'Observação (opcional)',
    licenceNote: 'Para licenças que o órgão não publica. Fica visível só para a sua conta e gera os lembretes de vencimento e de renovação.',
    licenceError: 'Não foi possível cadastrar a licença. Confira as datas.',
    save: 'Cadastrar',
    suggestions_one: 'Possível licença do titular ({{count}})',
    suggestions_other: 'Possíveis licenças do titular ({{count}})',
    suggestionsNote: 'A localização cai neste processo, mas o nome no órgão é outro. Confirme se é do titular: a resposta vale só para a sua conta, e uma licença confirmada passa a ter prazos e lembretes.',
    similarity: 'semelhança do nome {{pct}}%',
    mine: 'É do titular',
    notMine: 'Não é',
    confirmed: 'confirmada por você',
    undo: 'Desfazer',
    outsideTitle: 'Licenças ambientais — fora dos processos',
    openAtAgency: 'Abrir no SGA (IAT-PR) ↗',
    openRequest: 'Abrir no e-Protocolo (IAT-PR) ↗',
    ended_one: 'Encerrado ({{count}})',
    ended_other: 'Encerrados ({{count}})',
    outsideNote: 'Licenças dos titulares monitorados que o órgão não vincula a nenhum dos seus processos minerários (por exemplo, uma usina de beneficiamento). As vinculadas aparecem no processo, com prazos.',
    bases: { LP: 'LP — prévia', LI: 'LI — instalação', LO: 'LO — operação', LAS: 'LAS — simplificada', LAC: 'LAC — por adesão e compromisso', AA: 'Autorização ambiental' },
  },
  sei: {
    title: 'SEI da ANM',
    outsideTitle: 'SEI — processos sem processo minerário',
    outsideNone: 'Nenhum processo administrativo no SEI para estes titulares.',
    outsideLocked: 'Os processos administrativos do SEI aparecem com o módulo SEI.',
    outsideFailed: 'Não foi possível carregar os processos do SEI agora.',
    outsideDocuments_one: '{{count}} documento',
    outsideDocuments_other: '{{count}} documentos',
    outsideHomonym: 'possível homônimo',
    intro: 'Os processos do titular no SEI da ANM: os processos minerários e os administrativos (denúncias, autos, cobranças) em que ele é interessado. Documentos como publicados no SEI.',
    section: 'No SEI',
    lockedTitle: 'Acompanhe este processo no SEI',
    lockedBody: 'Com o módulo SEI você vê os documentos e o andamento do processo no SEI da ANM, os processos administrativos do titular e recebe um aviso quando chega um documento que pode gerar prazo.',
    lockedCta: 'Ver planos',
    unchecked: 'Ainda não consultamos este processo no SEI. A primeira consulta acontece em até um dia.',
    notOnSei: 'O SEI da ANM não tem processo com este NUP.',
    openOnSei: 'Abrir no SEI ↗',
    type: 'Tipo',
    createdOn: 'Aberto em {{date}}',
    interessados: 'Interessados',
    polledAt: 'Lido no SEI em {{date}}',
    notPolled: 'Ainda não lemos a página deste processo no SEI.',
    documents_one: 'Documentos: 1',
    documents_other: 'Documentos: {{count}}',
    noDocuments: 'Nenhum documento listado.',
    restricted: 'restrito',
    review: 'Revisar — pode gerar prazo',
    reviewNote: 'Documento de um tipo que costuma abrir prazo, emitido por uma unidade da ANM. O prazo não é calculado automaticamente: leia o documento.',
    linkedEvent: 'No Cadastro Mineiro: {{description}} · {{date}}',
    andamentos: 'Andamento',
    noAndamentos: 'Nenhum andamento listado.',
    mining: 'Processos minerários',
    administrative: 'Processos administrativos',
    noneMining: 'Nenhum processo minerário encontrado no SEI ainda.',
    noneAdministrative: 'Nenhum processo administrativo encontrado.',
    item: '{{type}} · {{documents}} documentos',
    lastDocument: 'último documento em {{date}}',
    administrativeProcess: 'Processo administrativo',
    miningProcess: 'Processo minerário {{ref}}',
    homonym: 'Possível homônimo',
    homonymBody: 'Encontramos este processo por um cadastro do SEI com o mesmo nome do titular, que também aparece em processos de outra empresa. Confirme se é do titular.',
    mine: 'É do titular',
    notMine: 'Não é do titular',
    confirmedMine: 'Você confirmou que este processo é do titular.',
    confirmedNotMine: 'Você indicou que este processo não é do titular: ele não gera mais avisos.',
    undo: 'Desfazer',
    hiddenNotMine_one: '1 processo marcado como não sendo do titular',
    hiddenNotMine_other: '{{count}} processos marcados como não sendo do titular',
    notFound: 'Processo não encontrado no SEI.',
    moduleRequired: 'Este processo faz parte do módulo SEI.',
    openPage: 'Página do processo no SEI — registrar prazo',
    onEvent: 'Documento no SEI: {{title}} · {{date}}',
    prazo: {
      add: 'Registrar prazo',
      title: 'Registrar prazo a partir deste documento',
      description: 'O que fazer',
      descriptionHint: 'Por exemplo: responder o ofício, apresentar documentos.',
      mode: 'Como informar o prazo',
      byDate: 'Data limite',
      byCount: 'Prazo contado',
      dueOn: 'Data limite',
      n: 'Prazo',
      unit: 'Unidade',
      units: { dias: 'dias', meses: 'meses', anos: 'anos' },
      startsOn: 'A partir de',
      countNote: 'Contamos como o Requerimento conta: o dia inicial é o primeiro dia do prazo. Fim de semana ou feriado não mudam a data, só a sinalizam.',
      save: 'Registrar',
      cancel: 'Cancelar',
      error: 'Não foi possível registrar o prazo. Confira a data e tente de novo.',
      listed: 'Prazo registrado: {{description}} · {{date}}',
      resolved: 'resolvido',
    },
  },
  ibama: {
    outsideTitle: 'IBAMA — fora dos processos',
    outsideNote: 'Autos, embargos e notificações do IBAMA contra os titulares monitorados cuja localização não cai em nenhum dos seus processos. Os que caem aparecem no processo, com prazo.',
    kind: { auto: 'Auto de infração', embargo: 'Termo de embargo', notificacao: 'Notificação' },
    inForce: 'em vigor',
    lifted: 'desembargado em {{date}}',
    attended: 'atendida',
    prazo_one: 'prazo de 1 dia',
    prazo_other: 'prazo de {{count}} dias',
  },
  finance: {
    title: 'Taxas e débitos',
    tahNotice: 'Cobrança de TAH',
    tahNoticeAmount: 'Cobrança de TAH: {{amount}}',
    tahNoticeKind: 'Notificação Administrativa nº {{number}}, publicada no Diário Oficial em {{date}}',
    tahDecisionKind: 'Decisão sem defesa da Notificação nº {{number}}, publicada no Diário Oficial em {{date}}',
    tahDue: 'TAH vencida em {{date}}',
    tahNoticeNote: 'Valor atualizado na data da notificação; a ANM acrescenta juros até o pagamento. Prazo de 10 dias para pagar ou apresentar defesa.',
    tahDecisionNote: 'Prazo de 10 dias para pagar ou parcelar, sob pena de inscrição em dívida ativa e CADIN.',
    pay: 'Pagar ou parcelar no Sinarc (ANM)',
    dou: 'Diário Oficial',
    debts_one: 'Dívida ativa do titular: 1 inscrição',
    debts_other: 'Dívida ativa do titular: {{count}} inscrições',
    debtsSource: 'Dados abertos da ANM (Procuradoria) — todas as inscrições do titular, não só deste processo; posição de {{date}}, a ANM não publica atualização mais recente.',
    debtsOpen_one: '1 em aberto · {{amount}}',
    debtsOpen_other: '{{count}} em aberto · {{amount}}',
    cfem: 'CFEM recolhida nos últimos 24 meses: {{amount}}',
    cfemSource: 'Dados abertos da ANM — último mês publicado: {{last}}.',
    cfemFines_one: 'Autos de infração de CFEM: 1',
    cfemFines_other: 'Autos de infração de CFEM: {{count}}',
    tah: 'TAH paga (histórico)',
    tahSource: 'Dados abertos da ANM, completos só até 2023. A situação atual da TAH aparece nos prazos, pelo Cadastro Mineiro.',
    unpaid: 'sem quitação',
    of: 'de {{total}}',
  },
  titularPicker: {
    label: 'Buscar titular',
    placeholder: 'Nome, CPF/CNPJ do titular ou número de processo',
    search: 'Buscar',
    pick: 'Escolher',
    change: 'trocar',
    none: 'Nenhum titular encontrado.',
  },
  partnerProgram: {
    title: 'Programa de parceiros',
    body: 'Consultorias parceiras recebem uma parte do que os clientes que elas trouxeram pagam, como crédito para usar nas próprias faturas ou resgatar por Pix.',
    untilApproved: 'Até aprovarmos sua parceria, os clientes que você trouxer não geram crédito. A partir da aprovação, os pagamentos de todos eles passam a contar.',
    phoneNote: 'Para participar, confirme um celular: é por ele que falamos com você se precisarmos confirmar a parceria.',
    join: 'Quero participar',
    skip: 'Agora não',
    failed: 'Não foi possível enviar o pedido agora. Tente de novo.',
    pending: 'Pedido de parceria em análise',
    pendingBody: 'Você já pode convidar clientes. O crédito começa a contar quando aprovarmos.',
    rejected: 'Pedido de parceria recusado',
    rejectedBody: 'Sua consultoria continua com a Carteira e os convites, sem comissão. Fale com a gente se quiser rever.',
  },
  quemPaga: {
    step: 'Cadastro da conta',
    title: 'Em nome de quem fica a conta?',
    subtitle: 'Uma pessoa (CPF) ou uma empresa (CNPJ): é em nome dela que saem as faturas e notas — e, para consultorias, as comissões. Conferimos os dados na Receita Federal; nada é cobrado agora.',
    kindCpf: 'Pessoa física (CPF)',
    kindCnpj: 'Empresa (CNPJ)',
    cpf: 'CPF',
    name: 'Nome completo, como na Receita',
    birthDate: 'Data de nascimento',
    cnpj: 'CNPJ',
    invitedBy: '{{label}} convidou você para monitorar {{titular}}. Cadastre a sua conta para continuar.',
    type: 'Tipo de conta',
    typeComum: 'Conta comum',
    typeComumHint: 'Você assina o monitoramento dos titulares que quiser e acompanha tudo aqui.',
    typeConsultoria: 'Consultoria',
    typeConsultoriaHint: 'Além de assinar, você convida seus clientes e acompanha na Carteira os processos que eles compartilharem com você.',
    document: 'Em nome de',
    submit: 'Conferir e continuar',
    submitting: 'Conferindo na Receita…',
    invalidCpf: 'Este CPF não é válido. Confira os números.',
    invalidCnpj: 'Este CNPJ não é válido. Confira os números.',
    missing: 'Preencha todos os campos.',
    errors: {
      verify_email_first: 'Confirme seu e-mail antes de cadastrar a conta.',
      blocked: 'Não foi possível continuar com este documento. Fale com o suporte.',
      customer_exists: 'Este documento já tem uma conta no Requerimento. Peça a quem administra essa conta para adicionar você.',
      too_many_checks: 'Você chegou ao limite de conferências na Receita por hoje. Tente de novo amanhã.',
      has_account: 'Este login já tem uma conta no Requerimento.',
      kyc_unavailable: 'A consulta à Receita Federal está fora do ar agora. Tente de novo em alguns minutos.',
      generic: 'Não foi possível conferir agora. Tente de novo; se continuar, fale com o suporte.',
    },
    reasons: {
      cpf_not_found: 'A Receita não encontrou este CPF.',
      cpf_not_regular: 'Este CPF não está regular na Receita.',
      name_mismatch: 'O nome não confere com o da Receita. Digite o nome completo, sem abreviar.',
      birth_date_unknown: 'A Receita não informa a data de nascimento deste CPF. Fale com o suporte.',
      birth_date_mismatch: 'A data de nascimento não confere com a da Receita.',
      cnpj_not_found: 'A Receita não encontrou este CNPJ.',
      cnpj_not_active: 'Este CNPJ não está ativo na Receita.',
      unknown: 'Os dados não conferem com os da Receita.',
    },
  },
  map: {
    moduleOnly: 'só módulo {{module}}',
    module: { ambiental: 'Ambiental', territorio: 'Território' },
    restrictionCard: 'Área de restrição',
    base: 'Base',
    basemap: { mapa: 'Mapa', satelite: 'Satélite' },
    layers: 'Camadas',
    soon: 'em breve',
    layerFailed: 'Camada indisponível: {{layer}}',
    basemapFailed: 'Mapa base indisponível',
    processCard: 'Processo no mapa',
    openProcess: 'Abrir processo →',
    close: 'Fechar',
    loadingLayers: 'Carregando camadas…',
    layersUnavailable: 'Camadas indisponíveis no momento — o mapa base continua visível.',
    zoomIn: 'Aproxime o mapa para ver os processos (zoom {{zoom}}+)',
  },
  sobreposicao: {
    title: 'Verificação de sobreposição',
    subtitle: 'Antes de protocolar, confira a área contra direitos ativos, bloqueios e unidades de conservação.',
    crs: 'SIRGAS 2000 · EPSG:4674',
    modes: { draw: 'Desenhar área', upload: 'Enviar KML ou GeoJSON', memorial: 'Memorial descritivo' },
    drawHint: 'Clique no mapa para marcar os vértices da área.',
    vertices_one: '{{count}} vértice',
    vertices_other: '{{count}} vértices',
    closePolygon: 'Fechar polígono',
    undo: 'Desfazer vértice',
    clear: 'Limpar',
    uploadLabel: 'Arquivo KML ou GeoJSON',
    uploadLoaded: 'Arquivo carregado: {{name}}',
    memorialLabel: 'Texto do memorial descritivo',
    check: 'Verificar sobreposição',
    checking: 'Verificando…',
    needArea: 'Desenhe ou envie uma área primeiro.',
    uploadError: {
      unreadable: 'Não conseguimos ler o arquivo.',
      no_polygon: 'O arquivo não contém nenhum polígono.',
      format: 'Envie um arquivo .kml, .geojson ou .json.',
    },
    error: {
      not_supported: 'A leitura de memorial descritivo ainda não está disponível. Envie a área em KML ou GeoJSON.',
      invalid_geometry: 'A área não pôde ser verificada.',
      generic: 'Não foi possível verificar a área agora.',
    },
    reason: {
      empty: 'A área está vazia.',
      no_polygon: 'Não encontramos um polígono na área enviada.',
      ring_too_short: 'O polígono precisa de pelo menos 3 vértices.',
      ring_not_closed: 'O polígono não está fechado.',
      bad_position: 'Há coordenadas inválidas.',
      outside_brazil: 'A área está fora do Brasil.',
      too_many_vertices: 'A área tem vértices demais (máximo 5.000).',
      too_large: 'A área é grande demais (máximo 50.000 ha).',
      empty_after_repair: 'A geometria é inválida (autointerseções).',
    },
    summary_one: '{{count}} ocorrência encontrada',
    summary_other: '{{count}} ocorrências encontradas',
    summaryNone: 'Nenhuma ocorrência nas camadas verificadas.',
    upsellTitle: 'O laudo completo é do Módulo Território',
    upsellBody: 'Veja quais processos interferem, a área de cada interseção e quanto fica livre para requerer.',
    upsellCta: 'Conhecer os planos',
    verdictBlocked: 'Não protocolar como está',
    verdictBlockedBody: 'A área invade {{ha}} de direitos ou áreas que impedem o requerimento.',
    verdictClear: 'Nenhuma interferência nas camadas verificadas',
    area: 'Área',
    consulted: 'Consultada',
    conflicting: '− em conflito',
    free: 'Livre para requerer',
    findings: 'Ocorrências — {{count}}',
    severity: { blocking: 'impeditivo', warning: 'atenção', info: 'informativo' },
    notChecked: 'Não verificado ainda: {{layers}}.',
  },
  multiSelect: {
    picked_one: '1 selecionada',
    picked_other: '{{count}} selecionadas',
    picked_zero: 'Nenhuma selecionada (todas)',
    clear: 'Limpar',
    none: 'Nenhuma opção.',
  },
  oportunidades: {
    title: 'Oportunidades',
    subtitle: 'Todas as áreas em disponibilidade, no mapa e na lista.',
    uf: 'UF',
    allUf: 'Todas as UFs',
    columns: { processo: 'Processo', substances: 'Substâncias', fase: 'Fase', uf: 'UF', area: 'Área', titular: 'Último titular', lastEvent: 'Última movimentação' },
    empty: 'Nenhuma área em disponibilidade com esses filtros.',
    views: 'Quais áreas',
    view: { near: 'Perto da carteira', all: 'Todas as áreas' },
    near: {
      subtitle: 'Áreas em disponibilidade perto dos seus processos, com a mesma substância ou um material parecido.',
      filters: 'Filtros das oportunidades',
      radius: 'Até',
      km: '{{km}} km',
      material: 'Material',
      materials: { igual: 'Mesma substância', parecida: 'Mesma ou parecida' },
      substance: 'Substância',
      allSubstances: 'Todas',
      summary_one: '{{count}} área a até {{km}} km dos seus processos · {{same}} com a mesma substância.',
      summary_other: '{{count}} áreas a até {{km}} km dos seus processos · {{same}} com a mesma substância.',
      truncated: 'Mostrando as {{count}} mais próximas — diminua o raio ou escolha "Mesma substância" para ver o resto.',
      noPortfolio: 'Nenhum dos seus processos tem poligonal e substância para buscar ao redor. Veja todas as áreas.',
      empty: 'Nenhuma área em disponibilidade com esse material nesse raio.',
      same: 'Mesma substância',
      family: 'Parecida · {{family}}',
      similar: 'Parecida',
      familyHint: 'Mesma família de {{own}}',
      distance: 'a {{km}}',
      touching: 'vizinha',
      mapLabel: 'Mapa das oportunidades perto da carteira',
      legend: { own: 'Seus processos', same: 'Mesma substância', family: 'Material parecido' },
      columns: { processo: 'Área', substance: 'Substância', near: 'Perto de', fase: 'Fase', area: 'Área (ha)', titular: 'Último titular' },
    },
    more: 'Carregar mais',
    checkOverlap: 'Checar sobreposição →',
  },
  superficiarios: {
    title: 'Superficiários',
    subtitle: 'Quem é dono do solo sobre a sua poligonal — e o estado de cada acordo.',
    soonTitle: 'Em breve',
    soonBody:
      'Esta tela cruza a poligonal com os imóveis do CAR (SICAR) e com a condição do solo informada à ANM. Esses dados ainda não estão no Requerimento; quando estiverem, os prazos dos acordos entram em Hoje e Prazos como qualquer obrigação.',
  },
  onboarding: {
    step: 'Passo 1 de 2 · Encontre sua carteira',
    title: 'Digite seu nome ou CNPJ — nós achamos tudo',
    subtitle:
      'A partir do registro público da ANM, reunimos seus processos e os agrupamos por titular. Confirme o que é seu; você escolhe o que monitorar no próximo passo.',
    label: 'Nome, CPF, CNPJ ou número de processo',
    placeholder: 'ex.: Mineração Sabatel · 12.345.678/0001-90 · 868.092/2015',
    search: 'Procurar',
    totalProcesses: 'processos',
    totalHolders: 'titulares (AnmEntities)',
    groups: 'Titulares agrupados',
    processes_one: '1 proc.',
    processes_other: '{{count}} proc.',
    monitor: 'Monitorar →',
    monitored: 'Já monitorado',
    none: 'Nada encontrado para “{{q}}” no registro público da ANM.',
    onlyTechnical: 'Encontramos você só como responsável técnico — nenhum título está em seu nome. Procure pelo nome ou CNPJ dos titulares.',
    alsoTechnical: 'Também encontramos você como responsável técnico em processos de outros titulares.',
    nothingCharged: 'Nada é cobrado ainda. A prévia mostra só dado público; monitorar exige confirmação de identidade.',
  },
  carteira: {
    title: 'Carteira',
    summary: 'Consultoria · {{clients}} clientes · {{processes}} processos ativos em {{ufs}} estados',
    empty: 'Nenhuma empresa subrogada a você ainda. Quando um cliente assinar e indicar você, ela aparece aqui.',
    byPhase: 'Por fase do processo',
    riskByClient: 'Risco por cliente',
    byUrgency: 'ordenado por urgência',
    showHidden: 'Mostrar ocultas',
    hideHidden: 'Esconder ocultas',
    hide: 'Ocultar',
    unhide: 'Mostrar',
    total: 'Total',
    days_one: '1 dia',
    days_other: '{{count}} dias',
    overdue_one: '1 vencido · {{days}} dias de atraso',
    overdue_other: '{{count}} vencidos · {{days}} dias de atraso',
    overdueTotal_one: '1 prazo vencido',
    overdueTotal_other: '{{count}} prazos vencidos',
    soon_one: '1 prazo em 90 dias',
    soon_other: '{{count}} prazos em 90 dias',
    cols: { client: 'Cliente', processes: 'Proc.', area: 'Área', next: 'Prazo mais urgente', requirements: 'Exig. abertas', fees: 'Taxas a vencer (90 dias)' },
  },
  planos: {
    kicker: 'Planos & módulos',
    title: 'Uma assinatura = (você × um titular)',
    subtitle: 'O plano segue o número de processos do titular; os módulos somam ao preço da assinatura.',
    tiersTitle: 'Faixa base — por nº de processos do titular',
    band: '{{min}}–{{max}} processos',
    bandOpen: '{{min}}+ processos',
    perMonth: '{{price}}/mês',
    talkToUs: 'Fale com a gente',
    suggested: 'sugerido',
    modulesTitle: 'Módulos — sobem o preço da assinatura',
    plusPerMonth: '+{{price}}/mês',
    ofPlan: '+{{pct}}% do plano',
    moduleAbout: {
      territorio: 'Sobreposições, áreas livres e o entorno no mapa.',
      ambiental: 'Restrições ambientais sobre as áreas.',
      superficiarios: 'Quem é dono da terra sobre cada processo.',
      api: 'Acesso aos dados por API e integrações.',
      sei: 'Os processos administrativos do SEI — dobra o preço do plano.',
    },
    annual: 'Anual −{{pct}}% (12 meses pagos agora)',
    footer: 'Subrogue a um consultor (1:1) sem custo. Mais de 150 processos → Enterprise, com preço combinado.',
    thisSubscription: 'Esta assinatura',
    entityLine_one: '1 processo · faixa {{tier}}',
    entityLine_other: '{{count}} processos · faixa {{tier}}',
    entityUncounted: 'faixa {{tier}}',
    today: 'Hoje, até {{to}}',
    thenMonthly: 'Depois, {{month}}/mês a partir de {{from}}, no dia 3 de cada mês.',
    thenAnnual: 'Equivale a {{month}}/mês (preço mensal {{list}}), pagos de uma vez pelos 12 meses.',
    overBand_one: '1 processo fica acima da faixa {{tier}} e aparece oculto até você mudar de plano.',
    overBand_other: '{{count}} processos ficam acima da faixa {{tier}} e aparecem ocultos até você mudar de plano.',
    signInToQuote: 'Entre para ver o total desta assinatura.',
    signIn: 'Entrar',
    quoteFailed: 'Não conseguimos calcular o total agora. Tente de novo em instantes.',
    pickHolder: 'Escolha o titular a monitorar.',
    pickHolderCta: 'Encontrar titular →',
  },
  checkout: {
    toConsultant: 'Dar acesso a estes processos à sua consultoria, {{label}}',
    toConsultantNote: 'Ela passa a acompanhar estes processos na Carteira dela, sem custo extra. A assinatura continua sua.',
    toConsultantFailed: 'A assinatura foi feita, mas a subrogação ao consultor não. Peça a ele para refazer o convite.',
    needCustomer: 'Antes de assinar, cadastre quem paga (CPF ou CNPJ).',
    needCustomerCta: 'Cadastrar →',
    ownerOnly: 'Só o responsável pela conta pode assinar ou mudar planos.',
    payWith: 'Pagar com',
    cardOnFile: 'Cartão {{brand}} final {{last4}} (recorrente)',
    cardNew: 'Cartão de crédito — você digita na página segura do Asaas',
    credit: 'Créditos (saldo {{balance}})',
    subscribe: 'Assinar este titular',
    activate: 'Assinar agora',
    trial: 'Testar {{days}} dias grátis',
    trialNote: 'O teste de {{days}} dias não pede cartão; confirmamos seu celular por SMS. Um teste por CPF/CNPJ, e-mail e celular.',
    inTrial: 'Em teste até {{date}}. Pagar com créditos encerra o teste e cobra a partir de hoje.',
    inTrialCard: 'Em teste até {{date}}. Com cartão, o teste continua: nada é cobrado hoje e a primeira cobrança é no fim do teste.',
    convert: 'Assinar no fim do teste',
    convertNewCard: 'Cadastrar cartão e assinar no fim do teste',
    converts: 'Assinatura agendada: começa em {{date}}, cobrada no {{card}}.',
    cardShort: 'cartão {{brand}} final {{last4}}',
    convertUndo: 'Desistir de assinar',
    verifyCard: 'Para cadastrar o cartão, fazemos uma cobrança pequena na página segura do Asaas e a estornamos em seguida. Nós não vemos o número do cartão.',
    verifyWaiting: 'Assim que o cartão for confirmado, a assinatura fica agendada — esta página atualiza sozinha.',
    trialStarted: 'Teste ativo até {{date}}.',
    toHoje: 'Ver o que exige ação →',
    alreadyActive: 'Este titular já está assinado.',
    activeNow: 'Pagamento confirmado — assinatura ativa.',
    toBilling: 'Ver cobrança →',
    trialUsed: 'O teste grátis já foi usado ({{what}}). Você pode assinar direto.',
    reason: { cpf: 'CPF', cnpj: 'CNPJ', email: 'e-mail', phone: 'celular' },
    blocked: 'Não conseguimos liberar o teste para este cadastro. Fale com o suporte.',
    refused: 'O cartão recusou o pagamento. Nada foi cobrado nem liberado.',
    refusedCta: 'Pagar com créditos ou cadastrar outro cartão →',
    short: 'Faltam {{missing}} no seu saldo de créditos (saldo {{balance}}). Adicione créditos e tente de novo.',
    retry: 'Já adicionei — tentar de novo',
    hostedCard: 'Para o primeiro pagamento com cartão, você digita os dados na página segura do Asaas. Nós não vemos o número do cartão.',
    openHosted: 'Abrir página segura do Asaas',
    confirming: 'Estamos confirmando o pagamento no cartão cadastrado.',
    waiting: 'O acesso é liberado assim que o pagamento confirmar — esta página atualiza sozinha.',
  },
  billing: {
    failed: 'Não deu certo. Tente de novo; se continuar, fale com o suporte.',
    providerRejected: 'O meio de pagamento recusou o pedido. Tente de novo em instantes.',
    phone: {
      title: 'Confirme seu celular',
      why: 'O teste grátis precisa de um celular confirmado (um teste por número).',
      number: 'Celular com DDD',
      send: 'Enviar código',
      sent: 'Enviamos um código de 6 dígitos por SMS.',
      code: 'Código',
      verify: 'Confirmar',
      change: 'Trocar número',
      invalidNumber: 'Digite um celular com DDD, ex.: (31) 99999-8888.',
      badCode: 'O código tem 6 dígitos.',
      wrongCode: 'Código incorreto ou expirado. Confira ou peça outro.',
      sendFailed: 'Não conseguimos enviar o SMS. Tente de novo.',
      tooMany: 'Muitas tentativas. Aguarde alguns minutos.',
    },
    pix: {
      title: 'Pagar com Pix',
      loading: 'Gerando o código Pix…',
      qrAlt: 'QR Code do Pix',
      copyPaste: 'Pix copia e cola',
      copy: 'Copiar código',
      copied: 'Copiado',
      expires: 'Válido até {{at}}',
      afterPaying: 'Depois de pagar, a confirmação chega em instantes.',
      nothingToPay: 'Esta cobrança não está mais em aberto.',
      failed: 'Não conseguimos gerar o código Pix agora.',
    },
    topup: {
      title: 'Adicionar créditos',
      amount: 'Valor',
      how: 'Como pagar',
      pix: 'Pix',
      boleto: 'Boleto',
      submit: 'Gerar cobrança',
      note: 'Mínimo {{min}}. Créditos pagam assinaturas, mudanças de plano e as faturas do dia 3; não são sacáveis.',
      invalid: 'Digite um valor, ex.: 150 ou 150,00.',
      belowMinimum: 'O mínimo é {{min}}.',
      created: 'Cobrança de {{amount}} gerada.',
      openBoleto: 'Abrir boleto',
    },
  },
  cobranca: {
    title: 'Cobrança',
    subtitle: 'Faturas, créditos, forma de pagamento e suas assinaturas.',
    ownerOnly: 'A cobrança é vista só pelo responsável pela conta.',
    banner: {
      billingOnly: 'Conta com pagamento em atraso há {{days}} dias: até o pagamento, só esta página fica disponível.',
      overdue_one: 'Fatura vencida há 1 dia. Pague para não perder o acesso a partir de {{from}}.',
      overdue_other: 'Fatura vencida há {{count}} dias. Pague para não perder o acesso a partir de {{from}}.',
      prewarn: 'Há uma fatura para pagar nos próximos dias — Pix ou boleto abaixo.',
      lowBalance: 'Seu saldo não cobre a fatura de {{date}}: faltam {{missing}}. Adicione créditos.',
    },
    kind: { cycle: 'Fatura mensal', activation: 'Ativação', upgrade: 'Mudança de plano' },
    invoices: {
      title: 'Em aberto',
      none: 'Nada em aberto.',
      due: 'vence {{date}}',
      overdue: 'venceu {{date}}',
      creditApplied: '{{amount}} já pagos com créditos',
      pix: 'Pix',
      boleto: 'Boleto',
      open: 'Abrir no Asaas',
    },
    credit: {
      title: 'Créditos',
      spendable: 'disponível para pagar',
      pending: 'comissão a liberar',
      note: 'Créditos pagam as faturas primeiro; não são sacáveis.',
      add: 'Adicionar créditos',
      openTopup: 'Recarga de {{amount}} por {{how}} aguardando pagamento',
    },
    method: {
      title: 'Forma de pagamento',
      card: 'Cartão {{brand}} final {{last4}} — cobrado no dia 3, sem avisos.',
      credit: 'Créditos — recarregue por Pix ou boleto; avisamos 7 dias antes se o saldo não cobrir.',
      cardNote: 'Para trocar de cartão, fazemos uma cobrança pequena na página segura do Asaas, estornada em seguida.',
      creditNote: 'Prefere cartão recorrente? Cadastre-o na página segura do Asaas (cobrança pequena, estornada em seguida).',
      addCard: 'Cadastrar cartão',
      replaceCard: 'Trocar cartão',
      backToCredit: 'Voltar para créditos',
      verification: 'Uma cobrança de {{amount}} confirma o cartão e é estornada em seguida.',
    },
    share: {
      invite: 'Convidar minha consultoria',
      with: 'Compartilhada com {{label}} — ela acompanha estes processos, sem acesso às suas faturas.',
      stop: 'Remover acesso',
      link: 'Envie este link à sua consultoria — vale até {{date}}:',
      copy: 'Copiar link',
      copied: 'Copiado',
      revoke: 'Cancelar convite',
    },
    subs: {
      title: 'Assinaturas',
      none: 'Nenhuma assinatura ainda.',
      start: 'Escolher um titular →',
      annual: 'anual',
      trialUntil: 'Teste até {{date}}',
      scheduled: 'Muda para {{plan}} em {{date}}',
      cancelOn: 'Não renova: acesso até {{date}}',
      changePlan: 'Alterar plano',
      activate: 'Assinar',
      cancelTrial: 'Cancelar teste',
      cancelRenewal: 'Cancelar renovação',
      undoCancel: 'Manter assinatura',
      converts: 'Assina {{plan}} no cartão em {{date}}, quando o teste termina.',
      undoChange: 'Desfazer a mudança',
    },
    status: { pending: 'aguardando pagamento', trial: 'em teste', active: 'ativa', cancelled: 'cancelada' },
    change: {
      tier: 'Plano',
      modules: 'Módulos',
      quoteNone: 'É o plano atual.',
      quoteScheduled: 'Sem cobrança agora: muda em {{date}}.',
      quoteCharge: 'Cobrança agora: {{amount}} (até o fim do período), liberada ao pagar.',
      quoteFailed: 'Não conseguimos calcular a mudança.',
      confirm: 'Confirmar mudança',
      cancel: 'Cancelar',
      close: 'Fechar',
      scheduled: 'Mudança marcada para {{date}}.',
      paid: 'Mudança paga e liberada.',
      charged: 'Cobrança de {{amount}} gerada; a mudança é liberada ao pagar.',
      none: 'Nada mudou.',
      short: 'Faltam {{missing}} no saldo de créditos. Adicione créditos e confirme de novo.',
    },
    paid: { title: 'Pagas' },
  },
  placeholder: { soon: 'Esta tela está em construção.' },
  alertas: {
    title: 'Alertas',
    subtitle: 'Escolha que tipo de evento chega até você e como: um e-mail na hora, ou uma linha no resumo diário, semanal ou mensal. Um padrão para todos os titulares, que você pode personalizar por titular.',
    defaultsTitle: 'Padrão para todos os titulares',
    defaultsBody: 'Vale para todo titular que não tenha uma configuração própria.',
    entitiesTitle: 'Por titular',
    noEntities: 'Nenhum titular monitorado ainda.',
    channel: 'Por {{channel}}',
    soon: 'em breve',
    enabled: 'Receber alertas',
    events: {
      title: 'O que avisar, e como',
      kind: 'Tipo de evento',
      how: { immediate: 'Na hora', daily: 'Diário', weekly: 'Semanal', monthly: 'Mensal' },
      when: 'Na hora: um e-mail assim que o evento aparecer. Diário: todo dia às 07:00. Semanal: às segundas-feiras, 07:00, com a semana anterior. Mensal: no dia 1º, 07:00, com o mês anterior. Um resumo vazio não é enviado.',
      module: { ambiental: 'módulo Ambiental', sei: 'módulo SEI' },
      kinds: {
        prazos: { label: 'Novos prazos', hint: 'Um prazo que exige ação. Se um prazo avisado deixar de existir, avisamos sempre.' },
        dou: { label: 'Publicações no DOU', hint: 'Atos sobre seus processos no Diário Oficial da União.' },
        scm: { label: 'Movimentações no Cadastro Mineiro', hint: 'Atos registrados pela ANM no Cadastro Mineiro (SCM).' },
        ambiental: { label: 'Atos de órgãos ambientais', hint: 'Licenças, autos de infração e embargos do IBAMA e dos órgãos estaduais.' },
        pedidos: { label: 'Pedidos acompanhados', hint: 'Um pedido que você acompanha mudou de situação (na hora) ou de setor (só nos resumos).' },
        sei: { label: 'SEI da ANM', hint: 'Processos novos com o titular como interessado e documentos que podem gerar prazo.' },
      },
    },
    reminders: 'Lembretes antes do vencimento',
    remindersBody: 'Um e-mail nos dias escolhidos antes de cada prazo em aberto (os da ANM e os que você cadastra), até ser marcado como ciente ou resolvido.',
    reminderDay0: 'No dia',
    removeDay: 'Remover lembrete D-{{day}}',
    addDayLabel: 'Outro (dias antes)',
    addDay: 'Adicionar',
    maxDays: 'No máximo {{max}} lembretes',
    processes_one: '{{count}} processo',
    processes_other: '{{count}} processos',
    inherits: 'usa o padrão',
    custom: 'personalizado',
    customize: 'Personalizar',
    close: 'Fechar',
    reset: 'Voltar ao padrão',
    saveFailed: 'Não foi possível salvar a alteração. O valor anterior foi mantido.',
  },
  descadastrar: {
    title: 'Cancelar alertas',
    ask: 'Você não receberá mais alertas de {{label}} por {{channel}}. Confirma?',
    confirm: 'Confirmar',
    done: 'Pronto. Você não receberá mais alertas de {{label}} por {{channel}}.',
    manage: 'Gerenciar meus alertas →',
    manageSignedOut: 'Para reativar ou ajustar seus alertas, entre no Requerimento e abra Alertas.',
    invalid: 'Este link de descadastro é inválido ou expirou. Abra Alertas no Requerimento para ajustar o que você recebe.',
    failed: 'Não foi possível concluir agora. Tente de novo.',
  },
  plan: {
    'tier.individual': 'Individual',
    'tier.essencial': 'Essencial',
    'tier.profissional': 'Profissional',
    'tier.avancado': 'Avançado',
    'tier.enterprise': 'Enterprise',
    'module.territorio': 'Território',
    'module.ambiental': 'Ambiental',
    'module.superficiarios': 'Superficiários',
    'module.api': 'API',
    'module.sei': 'SEI',
  },
  consultor: {
    eyebrow: 'Conta de consultoria · {{name}}',
    title: 'Minhas assinaturas',
    subtitle: 'Seus clientes pagam as assinaturas que compartilham com você; para você, o acesso é gratuito.',
    notConsultant: 'Esta área é para contas de consultoria.',
    stats: { members: 'usuários na equipe', entities: 'titulares geridos', subrogatedToYou: 'compartilhadas com você', youSubscribe: 'você assina' },
    byHolder: 'Por titular',
    cols: { holder: 'Titular', processes: 'Proc.', payer: 'Quem paga', modules: 'Módulos', next: 'Próx. prazo', subrogation: 'Compartilhada com' },
    payer: { holder: 'cliente paga', you: 'você assina' },
    noModules: 'base',
    days_one: '{{count}} dia',
    days_other: '{{count}} dias',
    late_one: '{{count}} dia de atraso',
    late_other: '{{count}} dias de atraso',
    empty: 'Nenhuma assinatura ainda. Convide um cliente ou assine o monitoramento de um titular.',
    subrogatedTo: 'compartilhada com {{label}}',
    notSubrogated: 'não compartilhada',
    subrogate: 'Subrogar…',
    subrogateLabel: 'CPF ou CNPJ do consultor',
    subrogateSave: 'Subrogar',
    subrogateRemove: 'Parar de compartilhar',
    cancel: 'Cancelar',
    subrogateErrors: {
      customer_not_found: 'Nenhuma conta com esse CPF/CNPJ no Requerimento.',
      cannot_subrogate_to_self: 'Não é possível subrogar à própria conta.',
      invalid_request: 'Digite 11 (CPF) ou 14 (CNPJ) dígitos.',
    },
    rule: 'Cada assinatura pode ser compartilhada com uma consultoria por vez; quem assina troca ou remove quando quiser.',
    plans: 'Ver planos e módulos →',
    credit: {
      title: 'Crédito acumulado',
      pending: '{{amount}} aguardando o prazo de estorno do cartão',
      approved: 'parceiro aprovado · ou use como desconto a um cliente',
      status: {
        pending: 'Candidatura a parceiro em análise — as comissões começam quando for aprovada.',
        rejected: 'Candidatura a parceiro não aprovada. Fale com o suporte se tiver dúvidas.',
        suspended: 'Parceria suspensa. Fale com o suporte.',
      },
      pixOff: 'O resgate por Pix ainda não foi liberado para a sua conta — o crédito pode ser usado como desconto.',
      redeem: 'Resgatar',
    },
    withdraw: {
      title: 'Resgatar por Pix',
      amount: 'Valor (R$)',
      keyType: 'Tipo de chave',
      keyTypes: { CPF: 'CPF', CNPJ: 'CNPJ', EMAIL: 'E-mail', PHONE: 'Celular', EVP: 'Chave aleatória' },
      key: 'Chave Pix',
      submit: 'Pedir resgate',
      note: 'O valor fica reservado na hora. Enviamos o Pix depois de receber a nota fiscal de serviço (CNPJ) ou o RPA (CPF) desse valor — as instruções chegam por e-mail.',
      done: 'Pedido de resgate nº {{id}} registrado. Confira seu e-mail para enviar a nota ou o RPA.',
      max: 'Disponível: {{amount}}',
      errors: {
        insufficient_credit: 'O valor é maior que o crédito disponível.',
        pix_redemption_off: 'O resgate por Pix não está liberado para a sua conta.',
        not_a_partner: 'Só parceiros aprovados podem resgatar.',
        invalid_pix_key: 'Chave Pix inválida.',
        invalid_request: 'Confira o valor e a chave.',
      },
      history: 'Resgates',
      status: { awaiting_document: 'aguardando nota/RPA', approved: 'Pix em envio', paid: 'pago', failed: 'falhou — valor devolvido', rejected: 'recusado — valor devolvido' },
    },
    invites: {
      title: 'Convidar um cliente',
      body: 'Escolha o titular que o cliente vai monitorar. Ele cria a conta (ou entra na que já tem), paga a assinatura e ela já vem compartilhada com você, sem custo para você.',
      titular: 'Titular a monitorar',
      madeFor: 'Convite para monitorar {{titular}}.',
      email: 'E-mail do cliente (opcional)',
      create: 'Gerar convite',
      sent: 'Convite enviado para {{email}}.',
      link: 'Link do convite — vale até {{date}}',
      copy: 'Copiar link',
      copied: 'Copiado',
      list: 'Convites',
      noEmail: 'só link',
      revoke: 'Revogar',
      state: { open: 'aberto', accepted: 'aceito', used: 'usado', revoked: 'revogado', expired: 'expirado' },
      errors: { not_a_partner: 'Só parceiros aprovados podem convidar.', invalid_request: 'Confira o e-mail e o CNPJ (14 dígitos).' },
    },
  },
  convite: {
    ownerOnly: 'Só o responsável pela sua conta pode assinar ou compartilhar o monitoramento de {{titular}}. Peça a ele para abrir este convite.',
    alreadyMonitors: 'Sua conta já monitora {{titular}}. Você pode dar acesso a {{label}} a essa assinatura, sem custo para ela.',
    shareExisting: 'Dar acesso a {{label}}',
    swap: 'Esta assinatura hoje é compartilhada com {{other}}. Trocar para {{label}} tira o acesso de {{other}}.',
    swapConfirm: 'Trocar para {{label}}',
    sharedDone: 'Pronto: {{label}} agora acompanha {{titular}}.',
    consultant: '{{inviter}} quer compartilhar com a sua consultoria o monitoramento de {{subject}}.',
    consultantHint: 'Sua consultoria passa a acompanhar estes processos na Carteira, sem custo. A assinatura continua sendo de quem convidou, e este compartilhamento não gera comissão.',
    acceptedConsultant: 'Pronto: a assinatura agora aparece na sua Carteira.',
    toCarteira: 'Ver a Carteira →',
    needConsultoria: 'Para aceitar, você precisa de uma conta de consultoria.',
    createConsultoria: 'Criar conta de consultoria →',
    takeAs: 'Aceitar como',
    acceptAs: 'Aceitar como {{name}}',
    title: 'Convite para o Requerimento',
    client: '{{inviter}} convidou você para monitorar {{subject}} no Requerimento.',
    member: '{{inviter}} convidou você para a equipe no Requerimento, como {{role}}.',
    roles: { owner: 'responsável', member: 'membro' },
    signUp: 'Criar conta',
    signIn: 'Já tenho conta — entrar',
    memberHint: 'Use o mesmo e-mail em que recebeu o convite.',
    validUntil: 'O convite vale até {{date}}.',
    accept: 'Aceitar convite',
    acceptedClient: 'Convite aceito.',
    acceptedMember: 'Pronto: você faz parte da equipe.',
    toHome: 'Ir para o painel →',
    invalid: 'Este link de convite é inválido.',
    state: {
      revoked: 'Este convite foi revogado por quem o enviou.',
      expired: 'Este convite expirou. Peça um novo a quem o enviou.',
      used: 'Este convite já foi usado.',
      accepted: 'Este convite já foi aceito.',
    },
    errors: {
      not_a_consultancy: 'Só uma conta de consultoria que você administra pode aceitar este convite.',
      own_subscription: 'Esta assinatura já é da sua conta.',
      own_invite: 'Este convite é para um cliente da sua consultoria — envie o link a ele.',
      already_in_account: 'Este login já pertence a outra conta. Use outro e-mail para entrar nesta equipe.',
      wrong_account: 'Este convite foi enviado para outro e-mail. Entre com a conta desse e-mail.',
      already_member: 'Você já faz parte desta equipe.',
      already_used: 'Este convite já foi usado por outra conta.',
      expired: 'Este convite expirou.',
      revoked: 'Este convite foi revogado.',
    },
  },
  equipe: {
    type: {
      title: 'Tipo de conta',
      comum: 'Conta comum',
      consultoria: 'Consultoria',
      toConsultoria: 'Transformar em consultoria',
      toConsultoriaHint: 'Uma consultoria ganha a Carteira e convida clientes para compartilharem assinaturas com ela. Você continua podendo assinar.',
      toComum: 'Voltar a conta comum',
      toComumHint: 'Só é possível enquanto nenhum cliente compartilha assinatura com esta consultoria.',
      errors: { has_clients: 'Há clientes compartilhando assinaturas com esta consultoria. Peça que removam o acesso antes de mudar o tipo.' },
    },
    title: 'Equipe',
    subtitle: 'Quem acessa {{name}}. Responsáveis cuidam de planos, pagamento e equipe; membros usam o painel. Cada pessoa escolhe os próprios alertas.',
    cols: { name: 'Nome', email: 'E-mail', role: 'Papel' },
    roles: { owner: 'Responsável', member: 'Membro' },
    you: 'você',
    remove: 'Remover',
    leave: 'Sair da equipe',
    confirmLeave: 'Sair da equipe de {{name}}? Você perde o acesso até ser convidado de novo.',
    lastOwner: 'A conta precisa de ao menos um responsável. Promova outra pessoa antes.',
    invite: 'Convidar pessoa',
    email: 'E-mail',
    role: 'Papel',
    send: 'Enviar convite',
    sent: 'Convite enviado para {{email}}. O link vale até {{date}}.',
    pending: 'Convites pendentes',
    revoke: 'Revogar',
    errors: { already_member: 'Essa pessoa já faz parte da equipe.', invalid_request: 'Confira o e-mail.', last_owner: 'A conta precisa de ao menos um responsável.', forbidden: 'Só responsáveis podem fazer isso.' },
    failed: 'Não foi possível salvar. Tente de novo.',
  },
  error: { title: 'Algo deu errado', body: 'Recarregue a página. Se continuar, fale com o suporte.', retry: 'Recarregar' },
  tech: {
    title: 'Detalhes técnicos',
    fromApi: 'Resposta do Requerimento.',
    beforeApi: 'Bloqueado antes de chegar ao Requerimento.',
    noAnswer: 'Sem resposta legível — bloqueio antes de chegar ao Requerimento ou falha de rede.',
    copy: 'Copiar detalhes',
    copied: 'Copiado',
  },
  sample: 'Dados de exemplo',
  processMap: { noGeometry: 'Sem polígono no SIGMINE para este processo.' },
  // Plan 7 (navigation redesign): one file per area
  shell: shellPt,
  atividades: atividadesPt,
  processos: processosPt,
  processoTabs: processoTabsPt,
  territorio: territorioPt,
} as const;
